<template>
    <ChildPage page-type="freelancers-child-page" />
</template>
<script lang="ts" setup>
    import {useWebsitePageView} from '#imports';
    import ChildPage from '~/components/ChildPage.vue';

    useWebsitePageView('cms', 'freelancers');
</script>
